
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RecipientsFilterService } from './recipients-filter.service';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';
import { Subscription } from 'rxjs';
import { RecipientsTableService } from '../table/recipients-table.service';
// TODO Rename and put in its own module



@Component({
  selector: 'dl-recipients-filter',
  templateUrl: './recipients-filter.component.html',
  styleUrls: ['./recipients-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class RecipientsFilterComponent implements OnInit, OnDestroy, AfterViewInit {
  public width = '202px';

  public sourceFormControl = new FormControl();
  public sourceList = [];
  public sourcePlaceholder = 'Source';
  public lblFilter: [];

  public lblFilter2: [];

  public warningFormControl = new FormControl();

  public warningsList = [];

  public warningPlaceholder = 'Warnings';

  public warningDataList = [];

  public srcFilteredDataList = [];

  public arrObj=[];

  private _sourceFormControlSubscription:Subscription;
  private _warningFormControlSubscription:Subscription;
  private _QnSbnDataServiceSubscription:Subscription;

  public constructor(private recipientsFilterService: RecipientsFilterService, private recipientsTableService: RecipientsTableService, private _QnSbnDataService:QnSbnDataService, private changeDetect:ChangeDetectorRef) {}
  
  warnings = [
    {label: "Email", value: "email"},
    {label: "Account IDs", value: "accId"}
  ];

  ngOnDestroy(): void {
    this._sourceFormControlSubscription.unsubscribe();
    this._warningFormControlSubscription.unsubscribe();
    this._QnSbnDataServiceSubscription.unsubscribe();
  }

  public ngOnInit(): void {

    this.recipientsTableService.srcFilterData$.subscribe(data=>{
      if(!this.recipientsTableService.isEmpty(data)){
        this.srcFilteredDataList = data;
        this.changeDetect.detectChanges();
      }       
    })
    
    this._QnSbnDataService.mappingData$.subscribe(data=>{
      if(!this._QnSbnDataService.isEmpty(data)){
        this.warningDataList=data['recipientData']['recipientTable']
        this.changeDetect.detectChanges();
      }
    })

    this._sourceFormControlSubscription = this.sourceFormControl.valueChanges.subscribe(val => {
      let val1=this.warningFormControl.value;
      if (val1) {
        this.lblFilter = val1.map(item => item.label.trim().toLowerCase());
        if (val) {
            this.lblFilter2 = val.map(item => item.label.trim().toLowerCase());
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
            this.recipientsFilterService.getFilteredData(this.lblFilter,this.srcFilteredDataList);
        }
        else {
            this.lblFilter2 = [];
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
            this.recipientsFilterService.getFilteredData(this.lblFilter,this.warningDataList);
        }
      }
      else{
          this.lblFilter = [];
          if (val) {
            this.lblFilter2 = val.map(item => item.label.trim().toLowerCase());
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
          }
          else {
            this.lblFilter2 = [];
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
          }
      }
    })

    

    this._warningFormControlSubscription = this.warningFormControl.valueChanges.subscribe(val => {
      let val1=this.sourceFormControl.value;
      if(val1){
        if (val) {
          this.lblFilter2 = val.map(item => item.label.trim().toLowerCase());
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.srcFilteredDataList);
        } 
        else {
          this.lblFilter2 = [];
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.srcFilteredDataList);
        }
      }
      else{
        if (val) {
          this.lblFilter2 = val.map(item => item.label.trim().toLowerCase());
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.warningDataList);
        } 
        else {
          this.lblFilter2 = [];
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.warningDataList);
        }
      }
    });
    this._QnSbnDataServiceSubscription = this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      if(!this._QnSbnDataService.isEmpty(storeData['recipientData'])){
        this.sourceList = storeData['recipientData']['sourceName'];
      }       
    })

    this.recipientsTableService.data$.subscribe((data:any[])=>{
      if(!this.recipientsTableService.isEmpty(data)){
        let res1=data.filter(i => {
          if(this.isDuplicatedEmail(data,i)){
            return i
          }
        });
        let res2=data.filter(i=>{
          if(i.customerId===undefined || '' || null){
            return i
          }
        })
        let res4=data.filter(i => {
          if(this.isDuplicatedName(data,i)){
            return i
          }
        });
        if(res1.length==0 && res2.length==0 && res4.length==0){
          this.warningsList = [];
        }
        else{
          this.warningsList = this.warnings;
        }
        this.changeDetect.detectChanges();
      }  
      else{
        this.warningsList = [];
        this.changeDetect.detectChanges();
      }     
    })    

    if((((typeof this.srcFilteredDataList === "object" && this.srcFilteredDataList.length==0)|| typeof this.srcFilteredDataList === "undefined") && ((typeof this.warningDataList  === "object" && this.warningDataList.length==0) || typeof this.warningDataList === "undefined"))){
      this.warningsList = [];      
      this.changeDetect.detectChanges();
    }
    else{
      this.warningsList = this.warnings;
      this.changeDetect.detectChanges();
    }

    this.recipientsTableService.dataStatus$.subscribe(data=>{
      if(!this.recipientsTableService.isEmpty(data)){
        this.warningsList = this.warnings;
        this.changeDetect.detectChanges();
      }  
      else{
        this.warningsList = [];
        this.changeDetect.detectChanges();
      }     
    })
    
    this.changeDetect.detectChanges();
  }

  public isDuplicatedEmail(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId &&
      obj.customerEmail === target.customerEmail);
    }

    public isDuplicatedName(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId && 
      obj.customerName !== target.customerName);
    }

  ngAfterViewInit(): void {
    this.recipientsTableService.srcFilterData$.subscribe(data=>{
      if(!this.recipientsTableService.isEmpty(data)){
        this.srcFilteredDataList = data;
      }       
    })

    this._QnSbnDataService.mappingData$.subscribe(data=>{
      if(!this._QnSbnDataService.isEmpty(data)){
        this.warningDataList=data['recipientData']['recipientTable']
      }
    })
    this.changeDetect.detectChanges();

    if((((typeof this.srcFilteredDataList === "object" && this.srcFilteredDataList.length==0)|| typeof this.srcFilteredDataList === "undefined") && ((typeof this.warningDataList  === "object" && this.warningDataList.length==0) || typeof this.warningDataList === "undefined"))){
      this.warningsList = [];      
      this.changeDetect.detectChanges();
    }
    else{
      this.warningsList = this.warnings;
      this.changeDetect.detectChanges();
    }

    this.recipientsTableService.dataStatus$.subscribe(data=>{
      if(!this.recipientsTableService.isEmpty(data)){
        this.warningsList = this.warnings;
        this.changeDetect.detectChanges();
      }  
      else{
        this.warningsList = [];
        this.changeDetect.detectChanges();
      }     
    })


    this.changeDetect.detectChanges();
  }
  
}
